"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartGrid = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var ChartGrid_styled_1 = require("./ChartGrid.styled");
/**
 * The lines in the background of the chart and their labels.
 * NOTE: The mobile labels are the most fragile part layout-wise
 * as they assume there are the same number of sets as labels and
 * that all sets are the same height.
 */
var ChartGrid = function (_a) {
    var grid = _a.grid, itemLabels = _a.itemLabels, _b = _a.barWidth, barWidth = _b === void 0 ? '1rem' : _b, formatter = _a.formatter, children = _a.children, rest = __rest(_a, ["grid", "itemLabels", "barWidth", "formatter", "children"]);
    var Small = (0, core_1.useComponents)().Small;
    return (react_1.default.createElement(ChartGrid_styled_1.StyledChartGridWrapper, __assign({}, rest),
        react_1.default.createElement(ChartGrid_styled_1.StyledMobileLabels, { "aria-hidden": "true" }, itemLabels.map(function (label, i) { return (react_1.default.createElement(ChartGrid_styled_1.StyledMobileLabel, { as: Small, key: "item-label-".concat(i), barWidth: barWidth }, label)); })),
        react_1.default.createElement(ChartGrid_styled_1.StyledChartChartContainer, null,
            react_1.default.createElement(ChartGrid_styled_1.StyledGridLabels, { "aria-hidden": "true" },
                grid.reverse().map(function (value, i) { return (react_1.default.createElement(ChartGrid_styled_1.StyledGridLabel, { key: "gridlabel-".concat(i) },
                    react_1.default.createElement(ChartGrid_styled_1.StyledGridLabelText, { as: Small }, formatter ? formatter(value) : value))); }),
                react_1.default.createElement(ChartGrid_styled_1.StyledGridLabel, null)),
            react_1.default.createElement(ChartGrid_styled_1.StyledGridChildren, null,
                react_1.default.createElement(ChartGrid_styled_1.StyledGridLines, null,
                    grid.map(function (_, i) { return (react_1.default.createElement(ChartGrid_styled_1.StyledGridLine, { key: "gridline-".concat(i) })); }),
                    react_1.default.createElement(ChartGrid_styled_1.StyledGridLine, null)),
                children))));
};
exports.ChartGrid = ChartGrid;
